import React from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * PreviewHeader Component
 * Header for theme preview
 */
const PreviewHeader = ({ theme }) => {
  return (
    <Typography
      variant="h5"
      gutterBottom
      sx={{
        color: theme.primary_color,
        fontFamily: theme.font_family,
        mb: 3,
      }}
    >
      Live Preview - {theme.theme_name}
    </Typography>
  );
};

PreviewHeader.propTypes = {
  theme: PropTypes.object.isRequired,
};

export default PreviewHeader;
